import React from 'react';
import { KTSVG } from '../../../_metronic/helpers';
import { getIconPath } from '../../../utils/iconMapping';
import type { FeatureListBlockContent } from '../../../types/popup.types';

interface FeatureListBlockProps {
  content: FeatureListBlockContent;
}

const FeatureListBlock: React.FC<FeatureListBlockProps> = ({ content }) => {
  const { items, iconColor, gap, align } = content;

  if (!items || items.length === 0) return null;

  // Hizalama mapping
  const getJustifyContent = () => {
    switch (align) {
      case 'left':
        return 'flex-start';
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default:
        return 'flex-start';
    }
  };

  return (
    <div style={{ width: '100%' }}>
      {items.map((item, index) => (
        <div
          key={index}
          className="d-flex align-items-center gap-3"
          style={{
            marginBottom: index < items.length - 1 ? `${gap || 8}px` : 0,
            justifyContent: getJustifyContent(),
          }}
        >
          <span 
            style={{ 
              flexShrink: 0,
              ...(iconColor && { color: iconColor })
            }}
          >
            <KTSVG
              path={getIconPath(item.icon)}
              className="svg-icon-2"
              svgClassName={iconColor ? 'fill-current' : 'fill-primary'}
            />
          </span>
          <span style={{ fontSize: '13px' }}>
            {item.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default FeatureListBlock;
